import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { ContactFullMergeData, ContactFullMergeSchema } from '../data/contact.full.merge.data';
import { SiteMergeData, SiteMergeSchema } from '../data/site.merge.data';
import { AccountMergeData, AccountMergeSchema } from '../data/account.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Contact,
})
export class ContactMergeDataset {
    @MergeSource({
        schema: ContactFullMergeSchema,
    })
    contact: ContactFullMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
    })
    relativeAccount: AccountMergeData

    @MergeSource({
        schema: SiteMergeSchema,
    })
    relativeSite: SiteMergeData
}